module.exports = __webpack_public_path__ + "img/logo.e610d202.png";